import { getBtlPlansApi } from '../contants';

export const getBtlPlans = (subscriberNo: string, isCopperUser: boolean, productId?: string) => {
	return {
		url: `${getBtlPlansApi}/${subscriberNo}?${isCopperUser ? `productId=${productId}` : ''}`,
		method: 'GET',
	};
};
